import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import { CircularProgress, Grid } from "@mui/material";
import "../../Assets/css/LifeInsurance/ProductListCard.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import SortHealthInsureProduct from "../../Components/Modals/SortHealthInsureProduct";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useNavigate, useParams } from "react-router";
import Axios from "axios";
import { useLocation } from "react-router";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
//import SRimg from '../../ShriramImage/SRimg.jpg'

function ProductListCard() {
  const [focus, setFocus] = useState(false);
  const [responseData, setResponseData] = useState([]);

  const [activeindex, setactiveindex] = useState();
  const [productdata, setProductdata] = useState({});
  const [transferDataa, setTransferData] = useState({});
  const [dialogState, setDialogState] = useState(false);

  const { id } = useParams();

  console.log(id, "id");
  const navigate = useNavigate();
  const location = useLocation();
  console.log(activeindex);
  var transferData;

  const SelectingCardHandler = (item, index) => {
    console.log(productdata, "data wants to pass");
    console.log("trans", item, index);

    let premiumFrequency;
    switch (item[0]) {
      case "Monthly":
        premiumFrequency = 1002;
        break;
      case "Quarterly":
        premiumFrequency = 1003;
        break;
      case "Half Yearly":
        premiumFrequency = 1004;
        break;
      case "Yearly":
        premiumFrequency = 1005;
        break;
      default:
        break;
    }
    transferData = {
      A_id: productdata.response.responses.A_id,
      Acuvisor_product_id: productdata.response.responses.Acuvisor_product_id,
      PolicyTerm: productdata.request.PolicyTerm,
      PremiumTerm: productdata.request.PremiumTerm,
      PremiumFrequency: premiumFrequency,
      SumProposed: item[1].SumAssured,
      PremiumProposed: productdata.request.PremiumProposed,
      Premium: item[1].BasicPremium,
      GST: item[1].BasicST,
      TotalPremium: item[1].TotalPrem,
      ApplicationNo: productdata.request.ApplicationNo,
      PlanNo: "130",
      Age: productdata.request.Age,
      Gender: productdata.request.Gender,
      IsSmoker: productdata.request.IsSmoker,
      product_ref: productdata.response.responses.product_ref,
      product_id: productdata.response.responses.product_id,
      UserID: productdata.request.UserID,
      //MobileNo: location.state.value,
      sp_config_id: productdata.response.responses.sp_config_id,
      vp_config_id: productdata.response.responses.vp_config_id,
      bi_config_id: productdata.response.responses.bi_config_id,
      payment_config_id: productdata.response.responses.payment_config_id,

      PremiumFrequencyString: item[0],
    };

    setTransferData(transferData);
    console.log(transferData, "transferdata");
    setactiveindex(index);
  };
  console.log(transferDataa, "otside");

  const changeStyle = () => {
    console.log("you just clicked");

    setFocus(true);
  };
  const buyPlanHandler = () => {
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.post(
      `${domain}/api/shriram/plp-validate/`,
      //"http://ec2-43-205-26-216.ap-south-1.compute.amazonaws.com/api/shriram/plp-validate/",
      transferDataa
    ).then((response) => {
      console.log(response.data);
      navigate(
        `/life-insurance/product-detail/${response.data.id}*${productdata.response.responses.Acuvisor_product_id}`
      );
    });

    // console.log(response.data,"outiside")
  };
  console.log(productdata, "response After set");

  useEffect(() => {
    /* "44a4bxedxPwGQtSnEzGzdejnCdtrDJqkJ6uqWwGbXmdx5zrjGdHivmr9pyd7x8rVQMgumwGPCfuwseieCg8tuN5jNNeMJPU" */
    //  Axios.get(`http://localhost:3002/api/v1/lifeInsurance/getQuickQuoteResponse}`).then(response=>{
    //   console.log(response,"response for PLP")
    //  })

    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_EXPRESS;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_EXPRESS;
    } else {
      domain = process.env.REACT_APP_UAT_EXPRESS;
    }

    Axios.get(
      `${domain}/api/v1/lifeInsurance/getQuickQuoteResponse/${id}`
    ).then((response) => {
      console.log(response.data, "response for PLP");
      response.data.map((field, ind) => {
        if (field.response.response_id === id) {
          console.log("data find", field);
        }
      });
      setResponseData(response.data[0]);

      setProductdata(response.data[0]);
    });
  }, []);

  const handleSearch = (val) => {
    console.log("search val", val.target.value, responseData);
    let incomingVal = val.target.value;
    let filterData = responseData.filter((item) => {
      if (incomingVal === "") {
        return item;
      } else if (
        item.product_name.toLowerCase() === incomingVal.toLowerCase()
      ) {
        return item;
      }
    });
    console.log("kkk", filterData.length);
    if (filterData.length > 0) {
      setProductdata(filterData);
    } else {
      setProductdata([]);
    }
  };

  const handleSort = () => {
    console.log("sort");
    setDialogState(true);
  };
  const handleCloseSort = () => {
    setDialogState(false);
  };

  const sortByPremium = (val) => {
    console.log("sss", val);
    if (val === "LOW") {
      let filterData = responseData.sort((a, b) => {
        return parseFloat(a.premium) - parseFloat(b.premium);
      });
      setProductdata(filterData);
      console.log("low sort", filterData);
    } else {
      let filterData = responseData.sort((a, b) => {
        return parseFloat(b.premium) - parseFloat(a.premium);
      });
      setProductdata(filterData);
    }
  };
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="">
      <div className="">
        <CategoryHeader title="Plan Suggested For You" />
      </div>

      <div className="form-container">
        <div className="searchbox_container">
          <div className="search_box">
            {""}
            <SearchIcon></SearchIcon>
            <input
              type="search"
              className="input_searchbox"
              placeholder="Search for plans"
              //onChange={(val) => handleSearch(val)}
            />
          </div>

          <button className="sort_btn" onClick={handleSort}>
            sort
          </button>

          <SortHealthInsureProduct
            open={dialogState}
            close={handleCloseSort}
            sortByPremium={sortByPremium}
          />
        </div>
        <div>
          {productdata && Object.entries(productdata).length > 0 ? (
            Object.entries(
              productdata.response.responses.ResultSet.Response
            ).map((item, index) => {
              //console.log('ii',item)
              if(item[0] === "Yearly" ) 
              return (
                <Card
                  className={
                    activeindex === index ? "card-Sec_active" : "card-Sec"
                  }
                  key={index}
                  onClick={() => SelectingCardHandler(item, index)}
                >
                  <img
                    className="pro_img"
                    src={productdata.response.responses.logo}
                  />
                  <div className="pro_content">
                    <div className="p_namepart">
                      <div className="product_heading">
                        Shriram Life Assured Savings Plan
                      </div>
                      {/* <CheckCircleOutlineRoundedIcon />
                  <CheckCircleOutlineIcon/> */}
                      {activeindex === index ? (
                        <CheckCircleIcon className="circle_tic" />
                      ) : (
                        <CheckCircleOutlineRoundedIcon />
                      )}
                    </div>
                    <div>
                      <div id="pro_name">{productdata.product_name}</div>
                    </div>
                    <div className="Amount">
                      <div>
                        <div className="Care_text">Term</div>
                        <div className="Care_text">{item[0]}</div>
                      </div>
                      <div>
                        <div className="Care_text">Sum Assured</div>
                        <div className="Care_text">
                          <b className="rupee_symp">&#2352;</b>{" "}
                          {item[1].SumAssured}
                        </div>
                      </div>
                      <div>
                        <div className="Care_text">Premium</div>
                        <div className="Care_text">
                          <b className="rupee_symp">&#2352;</b>{" "}
                          {item[1].BasicPremium}
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              );
              
            })
          ) : (
            <div className="text-center m-4 p-4">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
      <div className="btn-sec position-fixed bottom-0  ">
        <button className="Goback_btn text-capitalize" onClick={() => goBack()}>
          Go back
        </button>

        <button
          className="submitBtn text-capitalize"
          onClick={() => buyPlanHandler()}
          disabled={activeindex === undefined ? true : false}
        >
          Buy Now
        </button>
      </div>
    </div>
  );
}

export default ProductListCard;
